/**
 * 数据访问层（纯前端版）
 * ------------------------------------------------------------------
 * 页面里所有的数据读写都走这里，不再直接写死后端地址。
 * 当前 USE_MOCK = false：走同源相对路径 API_BASE=/api/ytmt，由 nginx 反代到 Go 后端。
 * 想在完全没后端的情况下看效果时，把下面的 USE_MOCK 改成 true 即可，
 * 数据来自 src/api/mockData.js + MOCK_NEWS + 本地图片。
 *
 * 前端已改成同源相对路径（不再写 http://localhost:8080），
 * 这样部署到任何域名都不用重新打包；真要换后台域名时，改 nginx 转发即可。
 */
import axios from "axios"
import mockCases from "./mockData"

// 纯前端模式下使用的新闻数据（切到后端后由接口提供）
export const MOCK_NEWS = [{
        id: 1,
        title: "RCEP 专题培训助力企业提升国际竞争力",
        tag: "行业资讯",
        author: "编辑部",
        date: "2021-07-21",
        summary: "为落实国务院关于“加大协定实施相关培训力度”的重要部署，商务部举办《区域全面经济伙伴关系协定》（RCEP）第二次线上专题培训。",
        content: "为落实国务院关于“加大协定实施相关培训力度”的重要部署，商务部举办《区域全面经济伙伴关系协定》（RCEP）第二次线上专题培训。\n\n培训聚焦 RCEP 对产业影响，帮助地方和企业熟悉协定内容和规则，提升管理水平和政策利用能力。",
        cover: "",
        sort: 10
    },
    {
        id: 2,
        title: "浅析水上休闲平台的形成与发展",
        tag: "公司新闻",
        author: "编辑部",
        date: "2022-01-31",
        summary: "水上休闲平台是指延伸到水面上的平台结构，主要产品涉及水上平台、游艇码头、水上浮桥、快艇码头、浮动码头等。",
        content: "前言：何为水上休闲平台？\n是指无动力或有动力的，以餐饮娱乐、观光旅游为目的的，延伸到水面上的平台结构。\n\n一、最原始的水上休闲平台——鱼排\n渔排的形成是渔民出于生存目的，出海捕鱼同时还要承担各类风险，因此渔排诞生了。\n\n二、现代模块化浮体\n模块化 HDPE 浮体具备抗风浪、耐腐蚀、免维护、可灵活组合等特点，已成为主流方案。",
        cover: "",
        sort: 5
    }
]


// ===================== 开关 & 地址 =====================
export const USE_MOCK = false

// 真实接口地址（USE_MOCK = false 时才生效）
export const API_BASE = "/api/ytmt"
// 图片/附件地址前缀（真实模式下，接口返回的 img 字段只是文件名）
export const UPLOAD_BASE = "/uploads/file"
export const ADMIN_TOKEN = "devtoken"

// 案例分类：type 与后台/接口保持一致
export const CASE_TYPES = [{
        type: 1,
        label: "游艇码头",
        router: "Marina"
    },
    {
        type: 2,
        label: "塑料浮筒",
        router: "Plasticfloat"
    },
    {
        type: 3,
        label: "船艇泊位",
        router: "Boat"
    },
    {
        type: 4,
        label: "光伏浮筒",
        router: "Photovoltaic"
    },
    {
        type: 5,
        label: "防浪堤",
        router: "Breakwater"
    },
    {
        type: 6,
        label: "海洋渔排",
        router: "Ocean"
    }
]

// ===================== 工具方法 =====================
function parseQuery(url) {
    const query = String(url).split("?")[1] || ""
    const params = {}
    query.split("&").filter(Boolean).forEach(pair => {
        const idx = pair.indexOf("=")
        const key = idx > -1 ? pair.slice(0, idx) : pair
        const val = idx > -1 ? pair.slice(idx + 1) : ""
        params[key] = decodeURIComponent(val)
    })
    return params
}

function ok(list) {
    return {
        data: {
            code: 0,
            msg: "ok",
            data: {
                list: list
            }
        }
    }
}

function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

function sortByDateDesc(list) {
    return list.slice().sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
}

// ===================== mock 实现 =====================
function mockRequest(path, params) {
    const name = String(path).replace(/^\/+/, "").replace(/\/+$/, "")
    if (name === "newsList") {
        if (params.id !== undefined && params.id !== "") {
            const hit = MOCK_NEWS.filter(item => String(item.id) === String(params.id))
            return delay(150).then(() => ok(hit))
        }
        return delay(150).then(() => ok(sortByDateDesc(MOCK_NEWS)))
    }
    if (name === "getList") {
        if (params.id !== undefined && params.id !== "") {
            const hit = mockCases.filter(item => String(item.id) === String(params.id))
            return delay(150).then(() => ok(hit))
        }
        if (params.type !== undefined && params.type !== "") {
            const list = mockCases.filter(item => String(item.type) === String(params.type))
            return delay(150).then(() => ok(sortByDateDesc(list)))
        }
        return delay(150).then(() => ok(sortByDateDesc(mockCases)))
    }
    // 其它接口（如 create）在纯前端模式下没有服务端可写，返回空结果
    return delay(150).then(() => ok([]))
}

// ===================== 对外 API =====================
/**
 * 请求封装，返回值结构与 axios 一致（res.data.data.list）
 * @param {Object} config { url: 'getList?type=1', method: 'get', params, data }
 */
export function request(config) {
    const url = (config && config.url) || ""
    const method = ((config && config.method) || "get").toLowerCase()
    const path = String(url).split("?")[0]
    if (USE_MOCK) {
        return mockRequest(path, Object.assign({}, parseQuery(url), config.params))
    }
    const query = Object.assign({}, parseQuery(url), config.params)
    return axios({
        url: API_BASE + "/" + path.replace(/^\/+/, ""),
        method: method,
        params: query,
        data: config.data,
        headers: ADMIN_TOKEN ? { "X-Admin-Token": ADMIN_TOKEN } : {},
        timeout: 60000
    })
}

/**
 * 图片地址解析
 * mock 模式下 img 已经是 webpack 处理好的本地图片地址，直接返回；
 * 真实模式下接口只返回文件名，这里补上 uploads 前缀。
 */
export function assetUrl(file) {
    if (!file) return ""
    if (USE_MOCK) return file
    if (/^(https?:|data:|\/\/)/.test(file)) return file
    return UPLOAD_BASE + "/" + String(file).replace(/^\/+/, "")
}

/** 案例列表 */
export function getCaseList(type) {
    return request({
        url: "getList?type=" + type,
        method: "get"
    })
}

/** 案例详情 */
export function getCaseDetail(id) {
    return request({
        url: "getList?id=" + id,
        method: "get"
    })
}

/** 新闻列表 */
export function getNewsList() {
    return request({
        url: "newsList",
        method: "get"
    })
}

/** 新闻详情 */
export function getNewsDetail(id) {
    return request({
        url: "newsList?id=" + id,
        method: "get"
    })
}

/** 新增新闻（后台用） */
export function createNews(data) {
    return request({
        url: "newsCreate",
        method: "post",
        data: data
    })
}

/** 修改新闻（后台用） */
export function updateNews(data) {
    return request({
        url: "newsUpdate",
        method: "post",
        data: data
    })
}

/** 删除新闻（后台用） */
export function deleteNews(id) {
    return request({
        url: "newsDelete?id=" + id,
        method: "get"
    })
}

export default {
    USE_MOCK,
    API_BASE,
    UPLOAD_BASE,
    CASE_TYPES,
    request,
    assetUrl,
    getCaseList,
    getCaseDetail,
    getNewsList,
    getNewsDetail,
    createNews,
    updateNews,
    deleteNews
}
